export function encodeBase64(value: string) {
	return btoa(value);
}

export function decodeBase64(value: string) {
	return atob(value);
}
